/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prop-types */
/* eslint linebreak-style: ["error", "windows"] */
/**
 * @file CustomerReportSettingsPage.jsx
 */
// external libs
import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { Helmet } from 'react-helmet-async';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Spinner from '../../../util/spinner-shim';
import sortBy from 'lodash/sortBy';
import Pump from '../../partials/Graphics/Pump';
import Valve from '../../partials/Graphics/Valve';
import WindMachine from '../../partials/Graphics/WindMachine';

import AppStore from '../../../stores/AppStore';
import AppDispatcher from '../../../dispatchers/AppDispatcher';

import Footer from '../../partials/Footer';
import NavigationBar from '../../partials/NavigationBar';
import { isNumber } from '../../partials/Inputs/Inputs';

import styles from '../../../../css/devicePage.module.css';
import styles2 from '../../../../css/home.module.css';
import withAppStore from '../../../util/withAppStore';

function CustomerReportsSettingPage(props) {
  const navigate = useNavigate();
  const { customerID: customerIDFromParams } = useParams();
  const [ruleInfo, setRules] = useState({ statusMessageIsVisible: true });

  const getRules = () => {
    AppDispatcher.dispatch({
      action: 'get-rules',
      customerID: customerIDFromParams,
    });
  };

  const goBack = React.useCallback(() => {
    navigate('/settings');
  }, [navigate]);

  const handleChange = (field: string, value: number, callback: any) => {
    setRules({
      [field]: isNumber(value) ? Number(value) : value,
      statusMessageIsVisible: false,
    });
    if (callback) callback();
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    AppStore.addChangeListener(handleChange);

    getRules();

    return () => {
      AppStore.removeChangeListener(handleChange);
    };
  }, []);

  const {
    auth: { logout },
    intl: { formatMessage },
    route: { path: page },
  } = props;

  const {
    data: { rules: { rules = [], ruleReady = false } = {} },
  } = AppStore;

  const ALL = formatMessage({
    id: 'general.all',
    defaultMessage: 'all',
    description: 'all groups label',
  });

  const DAILY = formatMessage({
    id: 'general.periodicity.daily',
    defaultMessage: 'Daily',
    description: 'daily periodicity',
  });

  const MONTHLY = formatMessage({
    id: 'general.periodicity.monthly',
    defaultMessage: 'Monthly',
    description: 'monthly periodicity',
  });

  const WEEKLY = formatMessage({
    id: 'general.periodicity.weekly',
    defaultMessage: 'Weekly',
    description: 'weekly periodicity',
  });

  const YEARLY = formatMessage({
    id: 'general.periodicity.yearly',
    defaultMessage: 'Yearly',
    description: 'yearly periodicity',
  });

  const REPORTS = formatMessage({
    id: 'customer.settings.reports',
    defaultMessage: 'Run Reports',
    description: 'reports label',
  });

  const PUMP = formatMessage({
    id: 'general.deviceType.pump',
    defaultMessage: 'Pump',
    description: 'pump label',
  });

  const WIND_MACHINE = formatMessage({
    id: 'general.deviceType.windMachine',
    defaultMessage: 'Wind Machine',
    description: 'wind machine label',
  });

  const VALVE = formatMessage({
    id: 'general.deviceType.valve',
    defaultMessage: 'Valve',
    description: 'Valve label',
  });

  const NEW_REPORT = formatMessage({
    id: 'general.new.runReport',
    defaultMessage: 'New Run Report',
    description: 'New Run Report button label',
  });

  const reportNameToDeviceType = (type) => ({
    // @ts-expect-error: Let's ignore <Pump /> height and width error
    pumpRunReport: ['pump', PUMP, <Pump height="60" width="60" />],
    valveRunReport: ['valve', VALVE, <Valve style={undefined} />],
    windMachineRunReport: [
      'windmachine',
      WIND_MACHINE,
      <WindMachine style={undefined} />,
    ],
  }[type] || 'ERROR');

  const periodicityDisplayValue = (periodicity: string) => ({
    daily: DAILY,
    monthly: MONTHLY,
    weekly: WEEKLY,
    yearly: YEARLY,
  }[periodicity]);

  const { id: customerID } = AppStore.getCustomer();

  const navButton = (
    ruleID: number,
    label: string,
    graphic: any,
    periodicity: string,
    groups: string,
  ) => (
    <div
      key={`${groups}-${periodicity}-${Math.random()}`}
      style={{ display: 'inline-block' }}
    >
      <Link
        to={`/${customerID}/settings/reports/${ruleID}`}
        className={styles.settingButtonCustomer}
      >
        <div className={styles.settingIcon} style={{ lineHeight: '54px' }}>
          {graphic}
        </div>
        <div className={styles.settingName}>
          <h4
            style={{
              whiteSpace: 'pre-wrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              textTransform: 'capitalize',
              marginBottom: '0px',
              marginTop: '0px',
            }}
            title={label}
          >
            {label}
          </h4>
        </div>
        <div className={styles.settingValue}>
          <h4 style={{ marginRight: '1em', fontSize: '1.25em' }}>
            {periodicityDisplayValue(periodicity)}
          </h4>
        </div>
      </Link>
    </div>
  );

  let navButtons: Array<any> = [];

  if (ruleReady) {
    sortBy(rules, (rule: any) => {
      const periodicity = rule?.recurrence?.periodicity ?? '';
      const deviceGroup = rule?.transport?.query?.deviceGroup ?? '';
      const reportTitle = rule?.transport?.settings?.reportTitle ?? '';

      return `${reportTitle}${deviceGroup.toString()}${periodicity}`;
    }).forEach((rule: any) => {
      const { id: ruleID } = rule;
      const groups = rule?.transport?.query?.deviceGroup ?? ALL;
      const reportTitle = rule?.transport?.query?.reportTitle ?? '';
      const periodicity = rule?.transport?.settings?.frequency ?? 'daily';
      const url = rule?.transport?.url ?? '';

      const reportName = new URL(url).pathname.split('/').pop();
      const [deviceType, label, graphic] = reportNameToDeviceType(reportName);
      navButtons.push(
        navButton(ruleID, reportTitle || label, graphic, periodicity, groups),
      );
    });
  } else {
    navButtons = [
      <Spinner
        key="spinner"
        name="double-bounce"
        style={{ width: '30px', marginLeft: 'auto', marginRight: 'auto' }}
      />,
    ];
  }

  return (
    <div>
      <Helmet>
        <title>{REPORTS}</title>
      </Helmet>
        <NavigationBar
          backFunc={goBack}
          page={page}
          name={REPORTS}
          logOut={() => logout(navigate)}
        />
        <div className={styles.pageWidth}>
          <div className={styles.pageContainer}>
            <Link
              style={{ overflowWrap: 'break-word' }}
              to={`/${customerID}/settings/reports/add`}
              className={styles.settingButtonCustomer}
            >
              <section
                className={`${styles2.userSection} h3 ${styles2.userSectionEdit}`}
                key="new-run-report-button"
                style={{ marginTop: '0px', marginBottom: '0px' }}
              >
                <div style={{ textAlign: 'center', margin: '23px 0px' }}>
                  <i
                    className="fa fa-plus"
                    style={{ marginRight: '1em', fontSize: '20px' }}
                  />
                  {NEW_REPORT}
                </div>
              </section>
            </Link>
            {navButtons}
          </div>
        </div>
        <Footer />
      </div>
  );
}

export default withAppStore(injectIntl(CustomerReportsSettingPage));
